import React from 'react'
import './Index.css'
import topleft from "../../../assets/jpg/leftTop.png"
import P from "../../../assets/jpg/P.png"
import Upi from "../../../assets/jpg/upi_icon.png"
import A from "../../../assets/jpg/A.png"
import L from "../../../assets/jpg/L.png"
import Y from "../../../assets/jpg/Y.png"
import An from "../../../assets/jpg/&.png"
import W from "../../../assets/jpg/W.png"
import I from "../../../assets/jpg/I.png"
import N from "../../../assets/jpg/N.png"
import game from "../../../assets/jpg/left.png"
import coins from "../../../assets/jpg/coins.png"
import center from "../../../assets/jpg/center.png"
import money from "../../../assets/jpg/money.png"
import girl from "../../../assets/jpg/girl.png"
import coins2 from "../../../assets/jpg/coins2.png"
import sack from "../../../assets/jpg/sack.png"
import bc1 from "../../../assets/jpg/bc1.png"
import bc2 from "../../../assets/jpg/bc2.png"
import bc3 from "../../../assets/jpg/bc3.png"
import sack2 from "../../../assets/jpg/sack2.png"
import cc from "../../../assets/jpg/cc.png"
import { logEvent } from 'firebase/analytics'
import { analytics } from '../../../firebase'


 
 
 
const Index = () => {
  const downloadHandler = () => {
    logEvent(analytics, "downloadHandler");
    window.open(
      "https://firebasestorage.googleapis.com/v0/b/star-hunt-prod.appspot.com/o/StarHuntRmgv0.06.apk?alt=media&token=48a26b83-80e7-47bc-8d3c-532f53fe8c7b",
      "_blank"
    );
  };
  return ( 
      <div className="home container-fluid" >
          <div className="row" >
          <div className="col-2 img-responsive" >
          <img className="img-fluid topLeft " alt="d" src={topleft} />
          </div>
         
          <div className="d-flex ml-sm-5 mt-4 col-8 justify-content-center"> 
          <div className="img-responsive alphabets mr-2">
          <img style={{"width": "100%","height": "100%" }} alt="f" src={P} /> 
          </div>
          <div className="img-responsive alphabets mr-1" >
          <img style={{"width": "100%","height": "100%" }}  alt="f" src={L} />
          </div>
          <div className="img-responsive alphabets mr-0" >
          <img style={{"width": "100%","height": "100%" }}  alt="f" src={A} />
          </div>
          <div className="img-responsive  alphabets ml-0 mr-1" >
          <img style={{"width": "100%","height": "100%" }}  alt="f" src={Y} />
          </div>
          <div className="img-responsive alphabets mr-1">
          <img style={{"width": "100%","height": "100%" }}  alt="f" src={An} />
          </div>
          <div className="img-responsive alphabets mr-1">
          <img style={{"width": "100%","height": "100%" }}  alt="f" src={W} />
          </div>
          <div className="img-responsive alphabets mr-1">
          <img style={{"width": "100%","height": "100%" }}  alt="f" src={I} />
          </div>
          <div className="img-responsive alphabets mr-1">
          <img style={{"width": "100%","height": "100%" }}  alt="f" src={N} />
          </div>
          </div>  
          </div>
          {/* View for medium and large screens */}
          <div className=" row d-none d-sm-none d-md-flex secondRow  mt-md-3 justify-content-center " >
              <div className=" img-responsive col-2 col-md-2 offset-md-2 align-self-start " >
                  <img className="img-fluid game" alt="f" src={game}  />
              </div>
              <div className="img-responsive col-2  col-md-1 align-self-end  " >
                  <img className="img-fluid coins" alt="f" src={coins}  />
              </div>
              <div className="img-responsive col-2 col-md-4" >
                  <img className="img-fluid center" alt="f" src={center}  />
              </div>
              <div className="img-responsive col-2  col-md-1 align-self-start " >
                  <img className="img-fluid coins" alt="f" src={coins}  />
              </div>
              <div className="img-responsive col-2 col-md-2" >
                  <img className="img-fluid money" alt="f" src={money}  />
              </div>
          </div>
          <div className="row d-none d-sm-none d-md-flex thirdRow mt-md-3  mt-sm-n5  justify-content-center " >
              <div className="img-responsive col-1 col-md-1 align-self-start" >
                  <img className="img-fluid coins2" alt="d" src={coins2} />
              </div>
              <div className="img-responsive col-3 col-md-1 mt-5 align-self-end" >   
                  <img className="img-fluid" alt="d" src={girl} />
              </div>
              <div type="button" className=" text-center  d-md-flex ms-md-5 me-md-5 col-2 col-md-6 align-self-start justify-content-start btn DonwloadBtn " >
                  <img className="bc1 " src={bc1} alt="d" />
                  <img className="bc2 " src={bc2} alt="d" />
                  <img className="bc3 " src={bc3} alt="d" />
                  <div onClick={downloadHandler} className="DonwloadBtnLink">Download now and get 20 INR as bonus </div>
              </div>
              <div className="img-responsive ml-5 col-1  col-md-1 align-self-center" >
                  <img className="img-fluid coins" alt="d" src={coins} />
              </div>
          </div>
          <div className="row d-none d-sm-none d-md-flex fourthRow" >
              <div className="img-responsive col-3 me-5 col-md-3 align-self-center">
                 <p style={{color: "#FFFFFF", fontSize: "1.5vw"}} >Withdraw real money with <img className="img-fluid upi" alt="d" src={Upi}  /></p>
                 
              </div>
              <div className="img-responsive col-1 col-md-2 ms-md-auto offset-md-2 align-self-center">
                  <img className="img-fluid coins" alt="d" src={coins} />
              </div>
              <div className="img-responsive col-4 me-auto col-md-2  align-self-start">
                  <img className="img-fluid sacks" alt="d" src={sack} />
              </div>
          </div>
          {/* view for small screens */}
          <div className="row mt-3 d-flex d-md-none justify-content-center" >
              <div className="img-responsive col-2 col-md-2 align-self-start " >
                  <img className="img-fluid " alt="f" src={coins2}  />
              </div>
              <div className="img-responsive col-4 align-self-end" >   
                  <img className="img-fluid" alt="d" src={girl} />
              </div>
              <div className="img-responsive col-2 col-md-2 align-self-start " >
                  <img className="img-fluid " alt="f" src={coins}  />
              </div>
              <div className="img-responsive col-4 col-md-2 align-self-end" >
                  <img className="img-fluid" alt="f" src={money}  />
              </div>
          </div>
          <div className="row mt-3 d-flex d-md-none  justify-content-center" >
              <div type="button" className=" text-center mr-5 d-flex justify-content-center   col-12 btn DonwloadBtn2 " style={{marginLeft :'20px'}} >
                  <div onClick={downloadHandler} className="DonwloadBtnLink2">Download now and get 20 INR as bonus </div>
              </div>
          </div>
          <div className="row mt-2 d-flex d-md-none  justify-content-center" >
              <div className="img-responsive col-4 col-md-2 align-self-start " >
                  <img className="img-fluid coins" alt="f" src={coins}  />
              </div>
              <div className="img-responsive col-4 col-md-2 align-self-end " >
                  <img className="img-fluid sack2" alt="f" src={sack2}  />
              </div>
          </div>
          <div className="row mt-0 d-flex d-md-none  justify-content-around" >
              <div className="img-responsive col-4 col-md-4 align-self-start " >
                  <img className="img-fluid cc" alt="f" src={cc}  />
              </div>
              <div className="img-responsive col-4 col-md-2 align-self-end " >
                  <img className="img-fluid coins" alt="f" src={coins}  />
              </div>
          </div>
          <div className="row mt-0 d-flex d-md-none  justify-content-between" >
              <div className="img-responsive col-8 me-auto col-md-4 align-self-center">
                 <p style={{color: "#FFFFFF", fontSize: "1rem"}} >Withdraw real money with  <img  className="img-fluid upi" alt="upi" src={Upi} /></p>
                
              </div>
              <div className="img-responsive col-4 col-md-4 align-self-start " >
                  <img className="img-fluid game" alt="f" src={game}  />
              </div>
          </div>
      </div>
          
     
  )
}

export default Index
